import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

interface DolomiteBrandIconProps extends IconWrapperProps {
  variant?: "light" | "dark";
}

function DolomiteBrandSvg(props: {
  variant?: "light" | "dark";
  className?: string;
}) {
  const variant = props.variant || "light";
  const fillColor = variant === "light" ? "#FAFAF9" : "#0C0A09";

  return (
    <svg
      className={props.className}
      fill="none"
      role="img"
      viewBox="0 0 20 9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Dolomite</title>
      <path
        d="M19.2208 5.62313L11.1748 0.418819C10.2285 -0.193213 8.87345 -0.127929 8.02128 0.571827L0 7.16749H1.79599C2.22455 7.16749 2.63825 7.02672 2.94295 6.77783L9.25246 1.61432C9.48284 1.42663 9.847 1.40827 10.1022 1.57352L18.0268 6.69826C18.1581 6.78395 18.168 6.90431 18.1309 6.99C18.0962 7.07568 17.9971 7.16749 17.8286 7.16749H7.46142L10.9295 4.31134H9.08153C8.65049 4.31134 8.2368 4.45211 7.9321 4.70304L3.17581 8.62004H17.9599C18.8418 8.62004 19.5974 8.17734 19.8847 7.48982C20.1721 6.80435 19.912 6.06991 19.2184 5.62313H19.2208Z"
        fill={fillColor}
      />
    </svg>
  );
}

export function IconDolomiteBrand(props: DolomiteBrandIconProps) {
  return (
    <IconWrapper {...props}>
      <DolomiteBrandSvg className={props.className} variant={props.variant} />
    </IconWrapper>
  );
}
